import React, { Component } from "react";
import CategoryPage from "./CategoryPage";

import { inject } from "mobx-react";
import { withRouter } from "react-router-class-tools";

@inject("UIStore")
class CategoryZdrowie extends Component {
  render() {
    this.props.UIStore.setCurrentAction(['category', 'category-zdrowie']);

    var props = { ...this.props };
    props.match.params.slug = "47,zdrowie";

    return <CategoryPage {...props} />;
  }
}
export default withRouter(CategoryZdrowie);